export enum ProfileVariantType {
    OnlyCert = 'OnlyCert',
    CertAndUsername = 'CertAndUsername',
}
